<template>
  <div class="drawer-wrapper">
    <el-drawer :wrapperClosable="true" :title="title" :visible.sync="manageBlockResourceEdit" size="50%"
               :before-close="AddNone">

      <div class="demo-drawer__content">

        <el-form :model="addFrom" size="medium" label-width="100px" class="mt35" :rules="rules" ref="ruleForm">

          <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
            <el-form-item label="推荐位" prop="type">
              <el-select placeholder="请选择推荐位类型" disabled v-model="addFrom.type" class="w100">
                <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
            <el-form-item label="小说" v-if="this.editID">
              <el-button type="primary" icon="el-icon-search" @click="addSelectMovies()">选择</el-button>
            </el-form-item>
            <el-form-item label="小说" v-else prop="movie_id">
              <el-button type="primary" icon="el-icon-search" @click="addSelectMovies()">选择</el-button>
            </el-form-item>
          </el-col>

          <div v-for="item in showMovies" :key="item.id">
            <el-col :xs="50" :sm="50" :md="50" :lg="50" :xl="50" class="mb20">
              <el-divider></el-divider>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
              <el-form-item label="推荐标题">
                <el-input v-model="item.name" placeholder="请输入推荐标题" clearable></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
              <el-form-item label="推荐封面">
                <el-image
                    style="width: 80px; height: 80px"
                    :src="item.full_cover"
                    :preview-src-list="[item.image]"
                    fit="cover">
                </el-image>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
              <el-form-item label="排序">
                <el-input v-model="item.sequence" placeholder="请输入排序" clearable></el-input>
              </el-form-item>
            </el-col>

          </div>

        </el-form>

      </div>
      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>

    </el-drawer>

    <el-dialog title="选择小说" :close-on-click-modal="false" :visible.sync="selectMovies" width="80%"
               :before-close="handleClose">

      <!-- 查询条件 -->
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35" ref="ruleForm">
        <el-row :gutter="35">

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="小说ID">
              <el-input v-model="queryParams.id" @change="getList" @clear="getList" placeholder="请输入小说ID"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="小说名称">
              <el-input v-model="queryParams.name" @change="getList" @clear="getList" placeholder="请输入小说名称"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button size="medium" type="primary" @click="getList">查询</el-button>
              <el-button size="medium" @click="reset">重置</el-button>
            </div>
          </el-col>

        </el-row>
      </el-form>

      <el-table
          ref="multipleTable"
          :data="tableData"
          size="medium"
          tooltip-effect="dark"
          @select="handleSelect"
          @select-all="handleSelectAll"
          border
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          v-loading="loading"
          :highlight-selection-row="true"
      >
        <el-table-column type="selection" width="55"></el-table-column>

        <el-table-column label="ID" width="120">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>

        <el-table-column label="小说名称">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>

        <el-table-column prop="name" label="来源">
          <template slot-scope="scope">
            <span v-if="scope.row.source == 0">秋分书城自制</span>
            <span v-if="scope.row.source == 1">版权引入</span>
          </template>
        </el-table-column>

        <el-table-column prop="name" label="评级">
          <template slot-scope="scope">
            <span v-if="scope.row.level == 1">S</span>
            <span v-if="scope.row.level == 2">A+</span>
            <span v-if="scope.row.level == 3">A</span>
            <span v-if="scope.row.level == 4">B</span>
            <span v-if="scope.row.level == 5">C</span>
          </template>
        </el-table-column>

        <el-table-column label="排序">
          <template slot-scope="scope">{{ scope.row.sequence }}</template>
        </el-table-column>

        <el-table-column label="微信审核">
          <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.audit_status_wx == 0">未审核</el-tag>
            <el-tag type="warning" v-else-if="scope.row.audit_status_wx == 1">审核中</el-tag>
            <el-tag type="success" v-else-if="scope.row.audit_status_wx == 2 || scope.row.drama_id != null">审核通过</el-tag>
            <el-tag type="danger" v-else-if="scope.row.audit_status_wx == 3">审核拒绝</el-tag>
            <el-tag type="info" v-else>未审核</el-tag>
          </template>
        </el-table-column>

        <!-- <el-table-column label="抖音审核">
          <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.audit_status_dy == 0">未审核</el-tag>
            <el-tag type="warning" v-else-if="scope.row.audit_status_dy == 1">审核中</el-tag>
            <el-tag type="success" v-else-if="scope.row.audit_status_dy == 2">审核通过</el-tag>
            <el-tag type="danger" v-else-if="scope.row.audit_status_dy == 3">审核拒绝</el-tag>
            <el-tag type="info" v-else>未审核</el-tag>
          </template>
        </el-table-column> -->

      </el-table>
      <!-- 分页组件 -->
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize"
                  @pagination="getList"/>
      <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="addMovie">确 定({{ selectMoviesArr.length }})</el-button>
            </span>
    </el-dialog>

  </div>
</template>

<script>

import {manageBlockAPI} from "@/api/appletlist/manageBlock";
import {processErrors} from "@/utils/errorHandler";
import {WorksListAPI} from "@/api/Works/WorksList";

export default {
  props: [
    'manageBlockResourceEdit',
    "blockID",
    "type",
    "info",
    "editID",
    "platform_type"
  ],
  components: {},
  data() {
    return {
      title: "新增",

      addFrom: {
        id: '',
        type: '',
        block_id: '',
        novel: [],
      },
      typeList: [
        {id: 1, name: 'Banner'},
        {id: 2, name: '强烈推荐'},
        {id: 3, name: '精品热门'},
        {id: 4, name: '多人收藏'},
        {id: 5, name: '热门榜'},
        {id: 6, name: '新书榜'},
        {id: 7, name: '收藏榜'},
      ],
      rules: {
        title: [
          {required: true, message: '请输入推荐标题', trigger: 'blur'},
        ],
        type: [
          {required: true, message: '请选择推荐位', trigger: 'blur'},
        ],
        movie_id: [
          {required: true, message: '请选择小说', trigger: 'blur'},
        ],
        weigh: [
          {required: true, message: '请输入排序', trigger: 'blur'},
        ],
      },

      selectMovies: false,
      selectMoviesArr: [],
      showMovies: [],

      queryParams: {
        pageNo: 1,
        pageSize: 10,
        id: '',
        name: '',
      },

      loading: false,
      total: 0,
      tableData: [],
    };
  },
  created() {
  },

  methods: {

    AddNone() {
      this.addFrom = {
        id: '',
        novel: [],
      }
      this.title = ""
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneManageBlockResourceFlag');
    },

    // 关闭弹窗
    handleClose(done) {
      this.selectMoviesArr = []
      this.showMovies = []
      this.selectMovies = false;
    },

    addPush() {
      this.addFrom.novel = Object.entries(this.showMovies).map(([key, value]) => ({
        novel_id: value.id,
        title: value.name,
        image: value.image_url,
        weigh: value.sequence,
      }));
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let api = manageBlockAPI()
          api.addBlockResource(this.addFrom).then(res => {
            if (res.code == 0) {
              this.$message({
                message: '创建成功',
                type: 'success'
              });
              this.$emit('AddManageBlockResourceok');
            } else {
              processErrors(res);
            }
          })
        } else {
          return false;
        }
      });

    },

    /**
     * 选中
     * @param array
     * @param obj
     */
    handleSelect(array, obj) {
      if (!this.editID) {//添加
        //1.判断是增加还是减少:增加-true,减少-false
        const isInArray = array.some(item => JSON.stringify(item) === JSON.stringify(obj));

        if (isInArray) {//如果是增加
          this.selectMoviesArr.push(obj)
        } else {//如果是减少
          this.selectMoviesArr = this.selectMoviesArr.filter(item => item.id !== obj.id);
        }
      } else {//编辑
        this.$refs.multipleTable.clearSelection();//取消选中

        this.selectMoviesArr = [];
        this.selectMoviesArr.push(obj);

        this.$nextTick(() => {
          this.selectMoviesArr.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(this.tableData.find(item => {
              return row.id == item.id;
            }), true)
          })
        })
      }
      this.selectMoviesArr = this.selectMoviesArr.filter(item => item !== null && item !== undefined && item !== '');
    },

    /**
     * 全选
     * @param val
     */
    handleSelectAll(val) {
      if (!this.editID) {//添加
        if (val.length > 0) {//全选
          this.selectMoviesArr = [...this.selectMoviesArr, ...val];
          this.selectMoviesArr = this.selectMoviesArr.filter((value, index, self) => index === self.findIndex((t) => (t.id === value.id)))
        } else {//取消全选
          this.selectMoviesArr = this.selectMoviesArr.filter(item1 => !this.tableData.find(item2 => item2.id === item1.id));
        }
      } else {//编辑禁止全选
        this.$message({
          message: '编辑状态禁止全选',
          type: 'error',
        });
        this.$refs.multipleTable.clearSelection();//取消选中
        this.$nextTick(() => {
          this.selectMoviesArr.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(this.tableData.find(item => {
              return row.id == item.id;
            }), true)
          })
        })
      }
      this.selectMoviesArr = this.selectMoviesArr.filter(item => item !== null && item !== undefined && item !== '');
    },

    addMovie() {
      this.selectMoviesArr = this.selectMoviesArr.filter(item => item !== null && item !== undefined && item !== '')
      this.showMovies = this.selectMoviesArr;
      this.selectMovies = false;
    },

    reset() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        id: '',
        name: '',
      }
      this.getList();
    },

    addSelectMovies() {
      this.selectMovies = true
      this.getList();
    },

    getList() {
      this.tableData = [];
      this.loading = true;
      let api = WorksListAPI()
      api.getVisibleList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount

          this.tableData.forEach(item => {
            let tx = '';
            let tt = '';
            if (item.goods_remark && item.goods_remark.tx) {
              tx = item.goods_remark.tx.join(',');
            }
            if (item.goods_remark && item.goods_remark.tt) {
              tt = item.goods_remark.tt.join(',');
            }
            item.weChatAudit = tx;
            item.tikTokAudit = tt;

          });

          this.$nextTick(() => {
            this.selectMoviesArr.forEach(row => {
              this.$refs.multipleTable.toggleRowSelection(this.tableData.find(item => {
                return row.id == item.id;
              }), true)
            })
          })

        } else {
          processErrors(res);
        }
        this.loading = false;
      })
    },
  },

  mounted() {
    this.addFrom.type = +this.type;
    this.addFrom.block_id = +this.blockID;
    this.addFrom.platform_type = +this.platform_type;
    this.addFrom.id = +this.editID;
    if (this.editID) {
      this.title = "编辑";
      this.addFrom.id = this.editID;
      this.selectMoviesArr = this.info;
      this.addMovie();
      // this.showMovies = this.selectMoviesArr;
    } else {
      this.addFrom.id = ''
      this.addFrom.novel = []
      this.selectMoviesArr = [];
      this.showMovies = [];
    }
  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  overflow-x: hidden;
}

.form-wrapper {
  padding-bottom: 80px; /* 给表单内容添加底部间距,留出按钮区域 */
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px 0;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

::v-deep .el-drawer__close-btn {
  font-size: 30px;
  font-weight: bold;
}
</style>
